export enum TaskStatusEnum {
  Pending = 1,
  WIP = 2,
  Closed = 3,
  Reopen = 4,
}
